
import EDPaper from '../../../../BaseComponents/Paper/EDPaper';
import EDTypography from '../../../../BaseComponents/Typography/EDTypography';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';

interface IProps {
  type: 'info' | 'warning' | 'error';
  children: React.ReactNode;
  testId?: string;
  classes?: any;
}

const styles = (theme: Theme) => ({
  root: {
    // TODO: färger till tema
    backgroundColor: theme.palette.grey['100'],
  },
  warning: {
    color: theme.customProperties.Warning.main,
  },
  error: {
    color: theme.palette.error.dark,
  },
});

/**
Område för att visa informationstext
*/
export const InfoArea = (props: IProps) => {
  return (
    <EDPaper
      className={classNames(props.classes.root, {
        [props.classes.warning]: props.type === 'warning',
        [props.classes.error]: props.type === 'error',
      })}
    >
      <EDTypography variant="body2" color="inherit" testId={props.testId}>
        {props.children}
      </EDTypography>
    </EDPaper>
  );
};

export default withStyles(InfoArea, styles);
